import React, { Component} from 'react';
import {
    Row,
    Col,
    List
} from 'reactstrap';
import { NavLink } from 'react-router-dom';
import simbaIcon from '../../assets/icon/simba_mobile_icon.png'
import imgBtnAppStore from "../../assets/btn-app-store.png"
import imgBtnPlayStore from "../../assets/btn-play-store.png"
import linkedinIcon from "../../assets/icon/linkedin.svg"
import facebookIcon from "../../assets/icon/facebook.svg"
import instagramIcon from "../../assets/icon/instagram.svg"
import youtubeIcon from "../../assets/icon/youtube.svg"
import "../../css/footer.css"

export default class DefaultFooter extends Component{
    
    render(){
        return(
            <footer className="footer bg-white py-3 px-3">
                <Row className='px-2'>
                    <Col>
                        <Row className='px-3 py-3'>
                            <Col lg={6} md={6} xs={12}>
                                <Row className='mb-2'>
                                    <Col lg={3} md={12} xs={12}>
                                        <span classname="fw-extrabold" style={{fontSize:16}}><b>Connect with us!</b></span>
                                    </Col>
                                    <Col lg={9} md={12} xs={12}>
                                        <a href="https://www.linkedin.com/authwall?trk=bf&trkInfo=AQFfjWk3S_JiCwAAAYZJeEwQpHM3LPE6m_RTFvaj1ifu5jm4IqSVCaMYoRpbcjLwPLT0QKGdgQB8HYqxVPoR4y5xpkcMOodPoNIotrIW7tBiY1J1IzpRYx4X3z4CbeHX7MUS-_M=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fsimbatelecom%2F">
                                            <img
                                                src={linkedinIcon}
                                                width={34}
                                            />
                                        </a>
                                        <a href="https://www.facebook.com/SIMBAtelecomSG">
                                            <img
                                                src={facebookIcon}
                                                width={37}
                                            />
                                        </a>
                                        <a href="https://www.instagram.com/simbatelecomsg/?hl=en">
                                            <img
                                                src={instagramIcon}
                                                width={37}
                                            />
                                        </a>
                                        <a href="https://www.youtube.com/channel/UCzFUkVZ0Q_fJGGpw7cEU0cg">
                                            <img
                                                src={youtubeIcon}
                                                width={38}
                                            />
                                        </a>
                                    </Col>
                                </Row>
                            </Col>
                            <Col lg={6} md={6} xs={12}>
                                <Row>
                                    <Col lg={6} md={12} xs={12}>
                                        <img
                                            src={simbaIcon}
                                            width="40px"
                                            className="mr-4 mb-2"
                                        />
                                        <span classname="fw-extrabold " style={{fontSize:16}}><b>Download our SIMBA app</b></span>
                                    </Col>
                                    <Col lg={6} md={12} xs={12}>
                                        <a href="https://apps.apple.com/sg/app/tpg-sg/id1542566692">
                                            <img
                                                src={imgBtnAppStore}
                                                style={{width:125}}
                                                className="mr-2"
                                            />
                                        </a>
                                        <a href="https://play.google.com/store/apps/details?id=com.tpg_sg">
                                            <img
                                                src={imgBtnPlayStore}
                                                style={{width:125}}
                                            />
                                        </a>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <hr/>
                        <Row className="px-3">
                            <Col lg={6} xs={12}>
                                <p style={{fontSize:14}}>Copyright © 2022 SIMBA Telecom Pte Ltd (UEN: 201617990D. Formerly known as TPG Telecom Pte Ltd) - All Rights Reserved</p>
                            </Col>
                            <Col lg={6} xs={12}>
                                <Row>
                                    <Col lg={4} md={3} xs={12}>
                                        <NavLink className="text-link non-underline-link" to="/terms" style={{fontSize:14}}>Terms and Conditions</NavLink>
                                    </Col>
                                    <Col lg={4} md={3} xs={12}>
                                        <NavLink className="text-link non-underline-link" to="/data-protection-notice" style={{fontSize:14}}>Data Protection Notice</NavLink>
                                    </Col>
                                    <Col lg={4} md={4} xs={12}>
                                        <NavLink className="text-link non-underline-link" to="/cis" style={{fontSize:14}}>Critical Information Summary</NavLink>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </footer>
        )
    }
}